import { trackSessionEvent as TSE } from "./createSession";
import { fetchCalendarOptions, setPreviewH5PGameExternal } from "@app/common/calendar/components/createSession/V3/store/CreateSessionSlice";
import { CREATE_SESSION_MODES as CSM } from "@app/common/calendar/components/createSession/V3/constants";

export const relevantSessionBeforeActions = {

};

export const relevantSessionAfterActions = {
  [fetchCalendarOptions.fulfilled]: (stateBefore, stateAfter) => {
    CSM.EDIT === stateAfter.createSession.mode && TSE("calendar_edit_event_dialog", stateAfter);
    CSM.DUPLICATE === stateAfter.createSession.mode && TSE("calendar_duplicate_event_dialog", stateAfter);
  },
  [setPreviewH5PGameExternal]: (stateBefore, stateAfter, action) => {
    const { source } = action?.payload;
    TSE("H5P_game_selecting", stateAfter, { source });
  },
};
